import React from 'react';
import { Button } from '@fiverr-private/button';
import { ChevronDownIcon } from '@fiverr-private/visuals';
import { Stack } from '@fiverr-private/layout_components';
import { useDropdownContext } from '@fiverr-private/dropdown';
import { useLogoMakerContext } from '../../context/LogoMakerContext';

export const LogoMakerTriggerButton = ({ children }) => {
    const {
        popoverContext: { open },
    } = useDropdownContext();
    const { isTransparent } = useLogoMakerContext();

    return (
        <Button variant="ghost" size="md" colorScheme={isTransparent ? 'white' : undefined}>
            <Stack gap="1" alignItems="center">
                {children}
                <Stack transform={open ? 'rotate(180deg)' : 'none'} transition="0.15s ease-in-out">
                    <ChevronDownIcon size="sm" />
                </Stack>
            </Stack>
        </Button>
    );
};
